import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import {
  addTimelineEvent,
  resetAddTimelineEvent,
} from "@academy-context/write/application/use-cases/admin/timeline-event-addition/add-timeline-event";

const initialState: ProcessingState = { processing: "idle" };

export const addTimelineEventReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(addTimelineEvent.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(addTimelineEvent.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(addTimelineEvent.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetAddTimelineEvent, () => {
    return initialState;
  });
});
